import React from 'react';

export const TrendingPostSkeleton = () => {
  return (
    <div className="flex w-full animate-pulse flex-col gap-2">
      <div>
        <div className="h-[42px] w-[42px] rounded-full bg-neutral100" />
      </div>
      <div className="h-[18px] w-full rounded-sm bg-neutral100" />
      <div className="h-24 w-full rounded-sm bg-neutral100" />
      <div className="-mx-2 -my-1 -ml-3 flex h-7 items-center gap-3 pl-3">
        <div className="h-6 w-[34px] bg-neutral100" />
        <div className="h-6 w-[34px] bg-neutral100" />
      </div>
    </div>
  );
};
